import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { SnackBarAction } from '../../models/snack-bar-types';

@Component({
  selector: 'qt-normal-snack-bar',
  templateUrl: './normal-snack-bar.component.html',
  styleUrls: ['./normal-snack-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NormalSnackBarComponent {
  private readonly snackBarRef = inject(
    MatSnackBarRef<NormalSnackBarComponent>
  );

  protected readonly data = inject<{
    messageKey: string;
    params?: string[];
    actions?: SnackBarAction[];
    icon?: string;
  }>(MAT_SNACK_BAR_DATA);

  protected handleAction(action: SnackBarAction): void {
    this.snackBarRef.dismiss();
    action.callback();
  }
}
